import SumMenuItem from "./SumMenuItem";
import { activeLink } from "../../utils/activeLink";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Restricted from "../../context/Restricted";
import { useAuth } from "../../context/AuthContext";

export default function MenuItem({ item, onClick, selectedParent }) {

    const [height, setHeight] = useState(42.05)
    const menuRef = useRef(null);
    const route = useLocation();
    const { user } = useAuth();

    const handleClick = () => {
        onClick(prevState => {
            return prevState === item?.name ? null : item?.name
        })
    }

    useEffect(() => {
        if (selectedParent === item?.name) {
            setHeight(42.05 + (menuRef?.current?.getBoundingClientRect().height || 0))
        } else {
            setHeight(42.05)
        }
    }, [selectedParent, user])

    return (
        <li className={`menu-item menu-item-animating${activeLink(item?.index, item?.name, route.pathname) ? " active" : ""} ${selectedParent === item?.name ? " open" : ""}`} style={{ height }}>
            {
                item?.link && item?.link !== "" ? (
                    <Link to={`/${item.link || ""}`}
                        className={`menu-link ${item?.items && item?.items.length > 0 ? "menu-toggle" : ""}`}>
                        <i className={`menu-icon tf-icons bx bx-${item?.icon}`} />
                        <div data-i18n="Form Elements">{item?.title}</div>
                    </Link>
                ) : (
                    <button className={`menu-link w-100 border-0 ${item?.items && item?.items.length > 0 ? "menu-toggle" : ""}`} onClick={handleClick}>
                        <i className={`menu-icon tf-icons bx bx-${item?.icon}`} />
                        <div data-i18n="Form Elements">{item?.title}</div>
                    </button>
                )
            }
            {
                item?.items && item?.items.length > 0 && (
                    <ul className="menu-sub" ref={menuRef}>
                        {
                            item?.items.map(item => {
                                return (
                                    <Restricted to={item?.permission || ""} key={item.id}>
                                        <SumMenuItem subItem={item} />
                                    </Restricted>
                                )
                            })
                        }
                    </ul>
                )
            }
        </li>
    )
}